define(["jquery", "underscore", "marionette"], function ($, _, Marionette) {
  let timerMs = 300000;
  let intervalId;
  return Marionette.View.extend({
    el: "#content_layout",

    ui: {
      //for demo_account/info.php
      moreBtn: ".more-btn",
      newSelectBoxForSorter: ".side-bar .new-select-box",
      newSelectBoxForLeverage: "#change_leverage .new-select-box",
      archiveAccountMenu: ".archive_account_menu",
      archiveAccountModal: "#remove_account",
      archiveAccountCancelBtn: "#archive_account_cancel_btn",
      archiveAccountBtn: "#archive_account_btn",

      changeLeverageMenu: ".change_leverage_menu",
      changeLeverageModal: "#change_leverage",
      changeLeverageCancelBtn: "#change_leverage_cancel_btn",
      changeLeverageBtn: "#change_leverage_btn",

      emailVerificationCancelBtn: "#email_verification_cancel_btn",
      emailVerificationBtn: "#email_verification_btn",
      emailCodeInput: "#input-email-code",

      errorMsgWrapper: "#error_msg_wrapper",

      changePasswordMenu: ".change_password_menu",
      changeReadonlyPasswordMenu: '.change_readonly_password_menu',

      additionalAccountBox: "#box_additional_account",

      showProfilePageBtn: "#btn_show_profile",

      inputHiddenAccountNo: "#hidden_account_no",

      updateBalance: "#update_balance",
      updateBalanceModal: "#update_balance_modal",
      updateBalanceBtn: "#update-balance-btn",
      balanceAmount: "#balance-amount",

      //for account/change_password_modal.php
      changePasswordModal: "#change_password",
      changePasswordAccountNoSpan: "#change_password_account_no",
      passwordInput: "#password",
      confirmPasswordInput: "#confirm_password",
      showPasswordTextBtn: "#show_password_btn_img",
      showConfirmPasswordTextBtn: "#show_confirm_password_btn_img",
      removePasswordTextBtn: "#remove_password_btn_img",
      removeConfirmPasswordTextBtn: "#remove_confirm_password_btn_img",
      validationUppercase: "#validation_uppercase",
      validationSpeicalCharacter: "#validation_specialChar",
      validationNumber: "#validation_number",
      validationLength: "#validation_length",
      validationConfirm: "#validation_confirm",
      showStep2Btn: "#btn_show_step2",

      toastSuccess: "#toast_success",
      toastSuccessText: "#toast_text_success",
      toastFail: "#toast_fail",
      toastFailText: "#toast_text_fail",

      leverage: "#leverage",
      leverages: "#leverages",

      newSelectBoxClick: ".dropdown-wrapper li",

      // readonly password
      changePasswordTitle: '#change-password-title',
      readonlyPasswordMustDiffer: '#readonly-password-must-differ',
    },

    redirectToProfilePage: function (e) {
      window.location.href = "/profile/verification";
    },

    redirectToAdditionalAccountPage: function (e) {
      if (e) e.preventDefault();

      let target = $(e.target);

      if (target.is("p") || target.is("img")) target = target.closest("a");

      if (target.hasClass("inactive")) return;

      window.location.href = "/demo_account/additional_account";
    },

    events: {
      "click @ui.additionalAccountBox": "redirectToAdditionalAccountPage",
      "click @ui.showProfilePageBtn": "redirectToProfilePage",
      "click @ui.changePasswordMenu": "showChangePasswordModal",
      "click @ui.changeReadonlyPasswordMenu": 'showReadonlyChangePasswordModal',
      "keyup @ui.passwordInput": "validatePasswordInputText",
      "keyup @ui.confirmPasswordInput": "validateConfirmPasswordInputText",
      "click @ui.showPasswordTextBtn": "changePasswordInputType",
      "click @ui.showConfirmPasswordTextBtn": "changeConfirmPasswordInputType",
      "click @ui.removePasswordTextBtn": "removePasswordInputValue",
      "click @ui.removeConfirmPasswordTextBtn":
        "removeConfirmPasswordInputValue",
      "click @ui.showStep2Btn": "showStep2Modal",

      "click @ui.moreAccountBtn": function (e) {
        this.getMoreAccounts();
      },

      "click @ui.moreBtn": function (e) {
        this.displayAccountSelectBox(e);
      },

      "click @ui.newSelectBoxForSorter": function (e) {
        this.displaySorterSelectBox(e);
      },

      "click @ui.newSelectBoxForLeverage": function (e) {
        this.displaySLeverageSelectBox(e);
      },

      click: function (e) {
        this.UnDisplaySelectBox(e);
      },

      "click @ui.archiveAccountMenu": function (e) {
        if (e) e.preventDefault();

        this.showArchiveAccountModal(e);
      },

      "click @ui.changeLeverageMenu": function (e) {
        if (e) e.preventDefault();

        this.showChangeLeverageModal(e);
      },

      "click @ui.archiveAccountCancelBtn": function (e) {
        this.hideArchiveAccountModal(e);
      },

      "click @ui.archiveAccountBtn": function (e) {
        this.archiveAccount(e);
      },

      "click @ui.changeLeverageCancelBtn": function (e) {
        this.hideChangeLeverageModal(e);
      },

      "click @ui.changeLeverageBtn": function (e) {
        this.changeLeverage(e);
      },

      "click @ui.emailVerificationBtn": function (e) {
        this.verifyEmailCode(e);
      },

      "click @ui.emailVerificationCancelBtn": function (e) {
        this.hideEmailVerificationModal(e);
      },

      "click @ui.updateBalance": function (e) {
        if (e) e.preventDefault();

        this.showUpdateBalanceModal(e);
      },

      "keyup @ui.balanceAmount": "validateBalanceAmountInputText",

      "click @ui.updateBalanceBtn": function (e) {
        this.updateBalance(e);
      },

      "click @ui.newSelectBoxClick": function (e) {
        this.changeLabel(e);
        this.changeInputVal(e);
      },

      "keyup @ui.emailCodeInput": function (e) {
        if (this.validateEmailCode(e))
          this.ui.emailVerificationBtn.attr("disabled", false);
        else this.ui.emailVerificationBtn.attr("disabled", true);
      },
    },

    initialize: function () {
      this.bindUIElements();
      this.passwordModalType = null; // null / write / readonly
    },

    displayAccountSelectBox: function (e) {
      e.stopPropagation();
      const accountId = e.currentTarget.children[1].id;
      const selectBoxs = document.querySelectorAll(".more-btn ul");
      const targetSelectBox = document.querySelector(`#${accountId}`);

      if (targetSelectBox.style.display === "none") {
        for (const selectBox of selectBoxs) {
          selectBox.style.display = "none";
        }
        targetSelectBox.style.display = "block";
      } else {
        targetSelectBox.style.display = "none";
      }
    },

    displaySorterSelectBox: function (e) {
      e.stopPropagation();
      const selectBox = document.querySelector("#account_sorter_select_box");
      if (selectBox.style.display === "block") {
        selectBox.style.display = "none";
      } else {
        selectBox.style.display = "block";
      }
    },

    UnDisplaySelectBox: function (e) {
      // unDisplay sorter select box
      const sorterSelectBox = document.querySelector(
        "#account_sorter_select_box"
      );
      sorterSelectBox.style.display = "none";

      // unDisplay account select boxes
      const accountSelectBoxes = document.querySelectorAll(".more-btn ul");
      for (const selectBox of accountSelectBoxes) {
        selectBox.style.display = "none";
      }
    },

    showArchiveAccountModal: function (e) {
      e.preventDefault();
      const that = this;
      const mt4AccountNo = $(e.target).data("account");
      const balance = $(e.target).data("balance");
      const currencyAbbr = $(e.target).data("currency");

      // open modal
      const $ArchiveAccountModal = that.ui.archiveAccountModal;
      $ArchiveAccountModal.modal({
        show: true,
      });

      // set mt4AccountNo in modal text
      const $accountHighlight = document.querySelector(".account-highlight");
      $accountHighlight.innerHTML = mt4AccountNo;

      const $balanceHighlight = document.querySelector(".balance-highlight");
      $balanceHighlight.innerHTML = `${balance} ${currencyAbbr}`;

      // set mt4AccountNo in value
      const $archiveAccountBtn = document.querySelector("#archive_account_btn");
      $archiveAccountBtn.value = mt4AccountNo;

      that.ui.inputHiddenAccountNo.val(mt4AccountNo);

      that.ui.archiveAccountBtn.prop("disabled", false);
    },

    showChangeLeverageModal: function (e) {
      e.preventDefault();
      const that = this;
      const mt4AccountNo = $(e.target).data("account");
      const leverage = $(e.target).data("leverage");
      const memberTypeCd = $(e.target).data("member_type_cd");

      const $ArchiveAccountModal = that.ui.changeLeverageModal;
      $ArchiveAccountModal.modal({
        show: true,
      });

      const $accountHighlight = document.querySelector(
        ".change-leverage-account-highlight"
      );
      $accountHighlight.innerHTML = mt4AccountNo;

      const $leverageHighlight = document.querySelector(
        ".change-leverage-leverage-highlight"
      );
      $leverageHighlight.innerHTML = leverage;

      const $chnageLeverageBtn = document.querySelector("#change_leverage_btn");
      $chnageLeverageBtn.value = mt4AccountNo;

      that.ui.inputHiddenAccountNo.val(mt4AccountNo);

      $.ajax("/rest_demo_account/ready_list", {
        method: "GET",
        data: { member_type_cd: memberTypeCd },
        success: function (data) {
          const leverage_list = data["leverages"];

          that.ui.leverages.html("");
          let optionsString = "";

          _.each(leverage_list, function (item, index) {
            optionsString +=
              "<li data-value='" +
              item.leverage +
              "'>" +
              item.leverageName +
              "</li>";
          });
          that.ui.leverages.append(optionsString);

          that.ui.leverage.val(
            that.ui.leverages.find("li").last().data("value")
          );
          const divLabel = that.ui.leverages.parent().find("div").first();
          divLabel.html(that.ui.leverages.find("li").last().html());
        },
      });

      that.ui.changeLeverageBtn.prop("disabled", false);
    },

    showUpdateBalanceModal: function (e) {
      e.preventDefault();
      const that = this;
      const mt4AccountNo = $(e.target).data("account");
      const currencyAbbr = $(e.target).data("currency");

      // open modal
      const $UpdateBalanceModal = that.ui.updateBalanceModal;
      $UpdateBalanceModal.modal({
        show: true,
      });

      // set mt4AccountNo in modal text
      const $accountHighlight = document.querySelector(
        ".update-balance-highlight"
      );
      $accountHighlight.innerHTML = mt4AccountNo;

      const $balanceUnit = document.querySelector('.balance-unit');
      $balanceUnit.innerHTML = currencyAbbr.toUpperCase();

      // set mt4AccountNo in value
      const $updateBalanceBtn = document.querySelector("#update-balance-btn");
      $updateBalanceBtn.value = mt4AccountNo;

      that.ui.inputHiddenAccountNo.val(mt4AccountNo);

      this.ui.updateBalanceBtn.removeClass("active");
    },

    validateBalanceAmountInputText: function (e) {
      const balanceAmount = this.ui.balanceAmount.val();
      if (balanceAmount && Number(balanceAmount) !== 0) {
        this.ui.updateBalanceBtn.addClass("active");
      } else {
        this.ui.updateBalanceBtn.removeClass("active");
      }
    },

    hideArchiveAccountModal: function (e) {
      e.preventDefault();
      const that = this;
      that.ui.archiveAccountModal.modal("hide");
    },

    archiveAccount: function (e) {
      if (e) e.preventDefault();
      var that = this;
      var mt4Account = that.ui.inputHiddenAccountNo.val();

      $("#holdon-overlay").css("display", "");

      $.ajax("/rest_demo_account/archive_mt4_account", {
        method: "POST",
        data: {
          mt4_account_no: mt4Account,
        },
        success: function (data) {
          location.reload();
        },
        error: function (xhr, textStatus, errorThrown) {
          $("#holdon-overlay").css("display", "none");

          var error = xhr.responseJSON;

          alert(error.error_message);
        },
      });
    },

    hideChangeLeverageModal: function (e) {
      e.preventDefault();
      const that = this;
      that.ui.changeLeverageModal.modal("hide");
    },

    changeLeverage: function (e) {
      if (e) e.preventDefault();
      var that = this;
      var mt4Account = that.ui.inputHiddenAccountNo.val();
      var leverage = that.ui.leverage.val();

      $("#holdon-overlay").css("display", "");

      $.ajax("/rest_demo_account/change_leverage", {
        method: "POST",
        data: {
          mt4_account_no: mt4Account,
          leverage: leverage,
        },
        success: function (data) {
          location.reload();
        },
        error: function (xhr, textStatus, errorThrown) {
          $("#holdon-overlay").css("display", "none");

          var error = xhr.responseJSON;

          alert(error.error_message);
        },
      });
    },

    // show first modal for write
    showChangePasswordModal: function (e) {
      this.passwordModalType = 'write';
      
      e.preventDefault();
      const mt4AccountNo = $(e.target).data("account");

      this.ui.changePasswordTitle.text(window.translations.ChangePassword_Title_Write);
      this.ui.readonlyPasswordMustDiffer.css('display', 'none');

      this.ui.inputHiddenAccountNo.val(mt4AccountNo);
      this.ui.changePasswordAccountNoSpan.text(mt4AccountNo);
      this.ui.changePasswordModal.modal({ show: true });

      this.removePasswordInputValue(e);
      this.removeConfirmPasswordInputValue(e);
    },

    // show first modal for readonly
    showReadonlyChangePasswordModal: function (e) {
      this.passwordModalType = 'readonly';

      e.preventDefault();
      const mt4AccountNo = $(e.target).data('account');

      this.ui.changePasswordTitle.text(window.translations.ChangePassword_Title_Readonly);
      this.ui.readonlyPasswordMustDiffer.css('display', 'none');

      this.ui.inputHiddenAccountNo.val(mt4AccountNo);
      this.ui.changePasswordAccountNoSpan.text(mt4AccountNo);
      this.ui.changePasswordModal.modal({show: true});

      this.removePasswordInputValue(e);
      this.removeConfirmPasswordInputValue(e);
    }, 

    changePasswordInputType: function (e) {
      const currentType = this.ui.passwordInput.attr("type");
      if (currentType == "password") {
        this.ui.passwordInput.attr("type", "text");
        this.ui.showPasswordTextBtn.attr(
          "src",
          "/assets/common/common/img/hide_eye_gray.svg"
        );
      } else {
        this.ui.passwordInput.attr("type", "password");
        this.ui.showPasswordTextBtn.attr(
          "src",
          "/assets/common/common/img/eye_icon_gray.svg"
        );
      }
    },

    changeConfirmPasswordInputType: function (e) {
      const currentType = this.ui.confirmPasswordInput.attr("type");
      if (currentType == "password") {
        this.ui.confirmPasswordInput.attr("type", "text");
        this.ui.showConfirmPasswordTextBtn.attr(
          "src",
          "/assets/common/common/img/hide_eye_gray.svg"
        );
      } else {
        this.ui.confirmPasswordInput.attr("type", "password");
        this.ui.showConfirmPasswordTextBtn.attr(
          "src",
          "/assets/common/common/img/eye_icon_gray.svg"
        );
      }
    },

    validatePassowrdTexts() {
      const password = this.ui.passwordInput.val();
      const confirmPassword = this.ui.confirmPasswordInput.val();

      const lengthRule = /^.{8,15}$/;
      const digitRule = /\d/;
      const specialCharRule = /[!@#$%^*+=-]+/;
      const uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;

      if (password != confirmPassword) {
        this.ui.showStep2Btn.removeClass("active");
        return;
      }

      if (
        lengthRule.test(password) &&
        digitRule.test(password) &&
        specialCharRule.test(password) &&
        uppercaseRule.test(password)
      ) {
        this.ui.showStep2Btn.addClass("active");
      } else this.ui.showStep2Btn.removeClass("active");
    },

    validatePasswordInputText(e) {
      const password = e.target.value;

      // password text가 없을때 validation 모두 숨김
      if (!password || password.length < 1) {
        this.ui.validationUppercase.removeClass("satisfied");
        this.ui.validationUppercase.css("display", "none");
        this.ui.validationSpeicalCharacter.removeClass("satisfied");
        this.ui.validationSpeicalCharacter.css("display", "none");
        this.ui.validationNumber.removeClass("satisfied");
        this.ui.validationNumber.css("display", "none");
        this.ui.validationLength.removeClass("satisfied");
        this.ui.validationLength.css("display", "none");
        this.validatePassowrdTexts();
        return;
      }

      // 글자수 8자 이상, 15자 이하
      const lengthRule = /^.{8,15}$/;
      if (lengthRule.test(password)) {
        this.ui.validationLength.addClass("satisfied");
        this.ui.validationLength.css("display", "flex");
      } else {
        this.ui.validationLength.removeClass("satisfied");
        this.ui.validationLength.css("display", "flex");
      }

      // 숫자 하나 이상 포함
      const digitRule = /\d/;
      if (digitRule.test(password)) {
        this.ui.validationNumber.addClass("satisfied");
        this.ui.validationNumber.css("display", "flex");
      } else {
        this.ui.validationNumber.removeClass("satisfied");
        this.ui.validationNumber.css("display", "flex");
      }

      // 특수문자 하나 이상 포함
      const specialCharRule = /[!@#$%^*+=-]+/;
      if (specialCharRule.test(password)) {
        this.ui.validationSpeicalCharacter.addClass("satisfied");
        this.ui.validationSpeicalCharacter.css("display", "flex");
      } else {
        this.ui.validationSpeicalCharacter.removeClass("satisfied");
        this.ui.validationSpeicalCharacter.css("display", "flex");
      }

      // 영문 대문자/소문자 포함
      const uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
      if (uppercaseRule.test(password)) {
        this.ui.validationUppercase.addClass("satisfied");
        this.ui.validationUppercase.css("display", "flex");
      } else {
        this.ui.validationUppercase.removeClass("satisfied");
        this.ui.validationUppercase.css("display", "flex");
      }

      this.validateConfirmPasswordInputText();
      this.validatePassowrdTexts();
    },

    validateConfirmPasswordInputText(e) {
      if (e) e.preventDefault();
      const confirmPassword = this.ui.confirmPasswordInput.val();
      const password = this.ui.passwordInput.val();

      if (!confirmPassword || confirmPassword.length < 1) {
        this.ui.validationConfirm.removeClass("satisfied");
        this.ui.validationConfirm.css("display", "none");
        this.ui.validationConfirm.text(
          window.translations.Register_PWdonotmatch
        );
        this.validatePassowrdTexts();
        return;
      }

      if (password == confirmPassword) {
        this.ui.validationConfirm.addClass("satisfied");
        this.ui.validationConfirm.css("display", "flex");
        this.ui.validationConfirm.text(window.translations.Register_PWmatch);
      } else {
        this.ui.validationConfirm.removeClass("satisfied");
        this.ui.validationConfirm.css("display", "flex");
        this.ui.validationConfirm.text(
          window.translations.Register_PWdonotmatch
        );
      }

      this.validatePassowrdTexts();
    },

    removePasswordInputValue(e) {
      if (e) e.preventDefault();
      this.ui.passwordInput.val("");
      this.ui.validationUppercase.removeClass("satisfied");
      this.ui.validationUppercase.css("display", "none");
      this.ui.validationSpeicalCharacter.removeClass("satisfied");
      this.ui.validationSpeicalCharacter.css("display", "none");
      this.ui.validationNumber.removeClass("satisfied");
      this.ui.validationNumber.css("display", "none");
      this.ui.validationLength.removeClass("satisfied");
      this.ui.validationLength.css("display", "none");
      this.ui.validationConfirm.removeClass("satisfied");
      this.ui.validationConfirm.text(window.translations.Register_PWdonotmatch);
      this.ui.showStep2Btn.removeClass("active");
    },

    removeConfirmPasswordInputValue(e) {
      if (e) e.preventDefault();
      this.ui.confirmPasswordInput.val("");
      this.ui.validationConfirm.removeClass("satisfied");
      this.ui.validationConfirm.css("display", "none");
      this.ui.validationConfirm.text(window.translations.Register_PWdonotmatch);
      this.ui.showStep2Btn.removeClass("active");
    },

    // excute change write password or readonly password
    showStep2Modal(e) {
      if (e) e.preventDefault();
      const that = this;

      if (!this.ui.showStep2Btn.hasClass("active")) {
        return;
      }

      if (this.passwordModalType == 'write') {
        this.changePassword(e);
      } else if (this.passwordModalType == 'readonly') {
          that.changeReadonlyPassword(e);
      } else {
          return;
      }
    },

    // change write password
    changePassword: function (e) {
      if (e) e.preventDefault();
      const that = this;

      $("#holdon-overlay").css("display", "");

      const mt4Account = that.ui.inputHiddenAccountNo.val();
      const newPassword = that.ui.passwordInput.val();
      const confirmNewPassword = that.ui.passwordInput.val();

      $.ajax("/rest_demo_account/change_password", {
        method: "POST",
        data: {
          mt4_account_no: mt4Account,
          new_password: newPassword,
          confirm_new_password: confirmNewPassword,
        },
        success: function (data) {
          $("#holdon-overlay").css("display", "none");
          that.ui.changePasswordModal.modal("hide");
          that.toastSuccess();
        },
        error: function (xhr, textStatus, errorThrown) {
          $("#holdon-overlay").css("display", "none");

          that.toastFail();
        },
      });
    },

    // change readonly password
    changeReadonlyPassword: function (e) {
      if (e) e.preventDefault();
      const that = this;

      $('#holdon-overlay').css("display", "");

      const mt4Account = that.ui.inputHiddenAccountNo.val()
      const newPassword = that.ui.passwordInput.val()
      const confirmNewPassword = that.ui.passwordInput.val()

      $.ajax("/rest_demo_account/change_readonly_password", {
        method: "POST",
        data: {
          mt4_account_no: mt4Account,
          new_password: newPassword,
          confirm_new_password: confirmNewPassword,
        },
        success: function (data) {
          $('#holdon-overlay').css("display", "none");
          that.ui.changePasswordModal.modal('hide');
          that.toastSuccess();
        },
        error: function (xhr, textStatus, errorThrown) {
          $('#holdon-overlay').css("display", "none");
          
          that.toastFail();
        },
      });
    },

    toastSuccess: function () {
      const mt4Account = this.ui.changePasswordAccountNoSpan.text();
      let html
      if (this.passwordModalType == 'readonly') {
        html = window.translations.AccountNo + ' ' + mt4Account + '<br/>' + window.translations.ChangePassword_Toast_Success_Readonly
      } else {
        html = window.translations.AccountNo + ' ' + mt4Account + '<br/>' + window.translations.ChangePassword_Toast_Success
      }
      this.ui.toastSuccessText.html(html);
      this.ui.toastSuccess.addClass("show");

      const that = this;
      setTimeout(() => {
        that.ui.toastSuccess.removeClass("show");
      }, 5000);
    },

    toastFail: function () {
      const mt4Account = this.ui.changePasswordAccountNoSpan.text();

      const html =
        window.translations.AccountNo +
        " " +
        mt4Account +
        "<br/>" +
        window.translations.ChangePassword_Toast_Fail;
      this.ui.toastFailText.html(html);
      this.ui.toastFail.addClass("show");

      const that = this;
      setTimeout(() => {
        that.ui.toastFail.removeClass("show");
      }, 5000);
    },

    updateBalance: function (e) {
      if (e) e.preventDefault();
      const that = this;

      if (!this.ui.updateBalanceBtn.hasClass("active")) {
        return;
      }

      $("#holdon-overlay").css("display", "");

      const mt4Account = that.ui.inputHiddenAccountNo.val();
      const balance = that.ui.updateBalanceModal.find("input").val();

      $.ajax("/rest_demo_account/update_balance", {
        method: "POST",
        data: {
          mt4_account_no: mt4Account,
          balance: balance,
        },
        success: function (data) {
          $("#holdon-overlay").css("display", "none");
          that.ui.updateBalanceModal.modal("hide");
          location.reload();
        },
        error: function (xhr, textStatus, errorThrown) {
          $("#holdon-overlay").css("display", "none");
          var error = xhr.responseJSON;
          alert(error.error_message);
        },
      });
    },

    displaySLeverageSelectBox: function (e) {
      const selectBox = $(event.target).children("ul");

      if (selectBox.css("display") === "none") {
        $(".dropdown-wrapper").hide();
      }

      selectBox.toggle();
    },

    changeLabel: function (e) {
      const liValue = $(event.target).html();
      const ul = $(event.target).parent();
      const selectBox = ul.parent();
      const divLabel = selectBox.children("div");
      ul.toggle();
      divLabel.html(liValue);
    },

    changeInputVal: function (e) {
      const liValue = $(event.target).data("value");
      const ul = $(event.target).parent();
      const selectBox = ul.parent();
      const input = selectBox.next("input");
      input.val(liValue).change();
    },
  });
});
